import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import comapnyOne from "../../../assets/img/atd.png";
import "./cardTwostyle.css";
import AOS from "aos";
import "aos/dist/aos.css";

const CardTwo = () => {
  const listItems = [
    "Developed responsive web pages using Gatsby.js and Next.js frameworks, and integrated CMS with Prismic.",
    "Implemented W3C standard responsive websites with SEO and schemas, enhancing page speeds through code optimization.",
    "Designed & implemented RESTful APIs to facilitate seamless communication between frontend and backend systems.",
    "Managed MySQL and Firestore databases to efficiently store and retrieve structured data.",
    "Debugged and resolved application issues to improve user experience.",
  ];

  //test
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Stack
      direction="column"
      className="main-wrapper-two"
      data-aos="fade-up-left"
    >
      <img
        src={comapnyOne}
        alt="img"
        style={{ maxHeight: "61px", maxWidth: "240px" }}
      />
      <div className="card-one-wrap">
        <Typography
          color="white"
          style={{
            fontFamily: "Titillium Web",
            fontWeight: "700",
            letterSpacing: "3px",
            maxWidth: "550px",
            fontSize: "22px",
          }}
        >
          Associate Software Engineer
        </Typography>
        <div>
          <Typography
            color="white"
            style={{
              fontFamily: "Titillium Web",
              fontWeight: "600",
              letterSpacing: "1px",
            }}
          >
            ( June 2023 - Present)
          </Typography>
        </div>
        <div className="in-detail">
          <Typography
            color="white"
            style={{
              fontFamily: "Titillium Web",
              fontWeight: "500",
              letterSpacing: "1px",
            }}
          >
            Initially began as a React frontend developer, now working as a
            fullstack developer with a focus on Node.js for backend development
          </Typography>
        </div>
        <div className="list">
          <ul>
            {listItems.map((item, index) => (
              <li key={index}>
                <Typography
                  color="white"
                  style={{
                    fontFamily: "Titillium Web",
                    fontWeight: 500,
                    letterSpacing: "1px",
                  }}
                >
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Stack>
  );
};

export default CardTwo;
